/**
 * @module StickyNav
 * @description Global Sticky Nav
 */
import { useContext, useEffect, useState } from "react";
import Link from "next/link";
import { FuelContext } from "@/providers/fuel-provider";
import styles from "./BannerCountdown.module.css";
import { trackEvent } from "@/js/helpers/tracking";
import { formatPhoneNumber } from "@/js/helpers/fuse";
import useAgentStatus from "@/hooks/useAgentStatus";
import { DEFAULT_FUSE_NUMBER } from "@/js/constants/cohesion";

const position = "BANNER COUNTDOWN";

/**
 * @function Component
 * @description
 */
const Component = ({ location = "GLOBAL" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { fuseNumber } = useContext(FuelContext);
  const { cartHeavy, openHours } = useContext(FuelContext);
  const phoneNumber = formatPhoneNumber(fuseNumber || DEFAULT_FUSE_NUMBER);
  const fetchStatus = useAgentStatus();

  useEffect(() => {
    if (openHours.length === 0) return;
    const data = fetchStatus(openHours);
    setIsOpen(data?.isOpen);
  }, [openHours, fetchStatus]);

  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    const data = {
      elementType: "BUTTON",
      position,
      location,
      text: "PHONE NUMBER",
      actionOutcome: "CLICKTOCALL",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  if (cartHeavy) {
    return <></>;
  }

  return (
    <>
      {isOpen && (
        <section className={`u-theme-dark ${styles.component}`}>
          <div className="l-container">
            <div className={styles.component__content}>
              <nav
                className={`navigation ${styles.component__navigation}`}
                aria-label="Call Now Banner"
              >
                We're Open! <span className="icon icon-stopwatch" />
              </nav>
              <p className={styles.component__phone}>
                <Link href={`tel:${phoneNumber}`} onClick={handleClick}>
                  Call now
                  <span className="icon icon-phone-2" /> <em>{phoneNumber}</em>
                </Link>
              </p>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Component;
